/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React__default, { createContext } from 'react';
var AccordionContext = /*#__PURE__*/createContext({
  disabled: false
});
var AccordionProvider = function AccordionProvider(_ref) {
  var disabled = _ref.disabled,
    children = _ref.children;
  return /*#__PURE__*/React__default.createElement(AccordionContext.Provider, {
    value: {
      disabled: disabled
    }
  }, children);
};
export { AccordionContext, AccordionProvider };